import { InputValidationResult } from "../input";
import { IValidationContext, IValidationRule } from ".";

type RuleValidationTrigger =
	| "input"
	| "inputFinished"
	| "anyInput"
	| "anyInputFinished"
	| "formSubmit";

type RuleValidationAction =
	| "input"
	| "inputFinished"
	| "stepSubmit"
	| "formSubmit";

interface IValidationRuleBuilder<TBuilder extends IValidationRuleBuilder<TBuilder>> {
	activateOn: (trigger: RuleValidationTrigger) => TBuilder;
	validateOn: (trigger: RuleValidationTrigger) => TBuilder;
	fixErrorOn: (trigger: RuleValidationTrigger) => TBuilder;
}

interface IValidationRuleWithBuilder<TValue> extends
	IValidationRule<TValue>,
	IValidationRuleBuilder<IValidationRuleWithBuilder<TValue>> {
}

abstract class ValidationRuleTriggers<TValue> implements IValidationRuleWithBuilder<TValue> {
	private _activationTrigger: RuleValidationTrigger;
	private _validationTrigger: RuleValidationTrigger;
	private _fixErrorTrigger: RuleValidationTrigger;

	public get activationTrigger(): RuleValidationTrigger {
		return this._activationTrigger;
	}

	public get validationTrigger(): RuleValidationTrigger {
		return this._validationTrigger;
	}

	public get fixErrorTrigger(): RuleValidationTrigger {
		return this._fixErrorTrigger;
	}

	constructor() {
		this._activationTrigger = "inputFinished";
		this._validationTrigger = "inputFinished";
		this._fixErrorTrigger = "input";
	}

	public activateOn(trigger: RuleValidationTrigger): IValidationRuleWithBuilder<TValue> {
		this._activationTrigger = trigger;
		return this;
	}

	public validateOn(trigger: RuleValidationTrigger): IValidationRuleWithBuilder<TValue> {
		this._validationTrigger = trigger;
		return this;
	}

	public fixErrorOn(trigger: RuleValidationTrigger): IValidationRuleWithBuilder<TValue> {
		this._fixErrorTrigger = trigger;
		return this;
	}

	public abstract validate(value: TValue, validationContext: IValidationContext): Promise<InputValidationResult>|InputValidationResult;
}

export {
	ValidationRuleTriggers,
	type RuleValidationTrigger,
	type IValidationRuleWithBuilder,
	type RuleValidationAction
};